export default __webpack_public_path__ + "static/media/decision_finished_but_not_competent.0b7ef3e1.png";